module.exports = __webpack_public_path__ + "img/04.91f8fc39.png";